class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  connectedCallback() {
    this.toggleResetButton();
  }

  toggleResetButton() {
    if (!this.resetButton || !this.input) return;

    const hasValue = this.input.value.length > 0;

    if (hasValue) {
      this.resetButton.classList.remove('hidden', 'pointer-events-none', 'opacity-0');
      this.resetButton.removeAttribute('aria-hidden');
      this.resetButton.removeAttribute('tabindex');
      this.input.classList.add('filled');
    } else {
      this.resetButton.classList.add('hidden', 'pointer-events-none');
      this.resetButton.classList.remove('opacity-0');
      this.resetButton.setAttribute('aria-hidden', 'true');
      this.resetButton.setAttribute('tabindex', '-1');
      this.input.classList.remove('filled');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
